import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY_INFO } from '../../mock';

export const HeroUnfallgutachten = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center pt-24 pb-20 overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text Content */}
          <div className="space-y-8 animate-fadeInUp">
            {/* H1 - SEO optimiert */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.1] tracking-tight">
              Unfallgutachten
              <br />
              <span className="gradient-text">unabhängig, bundesweit,</span>
              <br />
              <span className="text-gray-400 text-2xl sm:text-3xl lg:text-4xl">direkt vor Ort</span>
            </h1>

            {/* Subline */}
            <p className="text-lg lg:text-xl text-gray-400 leading-relaxed">
              Schadensbegutachtung nach Verkehrsunfällen.
              Schnell, objektiv und ausschließlich Ihren Interessen verpflichtet.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a href={`tel:${COMPANY_INFO.phone}`}>
                <Button size="lg" className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-dark text-white text-base px-8 py-6 rounded-xl font-semibold shadow-xl shadow-brand-green/30">
                  <Phone className="w-5 h-5 mr-2.5" />
                  Jetzt anrufen
                </Button>
              </a>
              <a href={`https://wa.me/${COMPANY_INFO.whatsapp}`} target="_blank" rel="noopener noreferrer">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-gray-900 text-base px-8 py-6 rounded-xl font-semibold">
                  <MessageCircle className="w-5 h-5 mr-2.5" />
                  WhatsApp
                </Button>
              </a>
            </div>

            {/* Small note */}
            <p className="text-sm text-gray-400">
              Kostenlose Erstberatung • Kostenübernahme durch Versicherung in der Regel möglich
            </p>
          </div>

          {/* Right: Image */}
          <div className="relative lg:block hidden">
            <div className="relative rounded-2xl overflow-hidden">
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent z-10"></div>
              
              <img 
                src="https://customer-assets.emergentagent.com/job_gutachten-direkt/artifacts/kxj8u3gg_09CFACA3-5180-4552-916F-A831F42C883E.png"
                alt="Professionelle Schadenbegutachtung mit digitalem Tablet - Papierlos und modern"
                className="w-full h-auto object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
